import moment from "moment";
export const prepareCertificado = async (certificado = {}) => ({
  ...certificado,
  fecha: certificado.fecha !=='' ? moment(certificado.fecha).toDate() : null,
  fechaBaja: certificado.fechaBaja !== '' ? moment(certificado.fechaBaja).toDate() : null,
  fechaCarga: certificado.fechaCarga !== '' ? moment(certificado.fechaCarga).toDate() : null,
  fechaModificacion: certificado.fechaModificacion !== '' ? moment(certificado.fechaModificacion).toDate() : null,
  fechaNacimiento: certificado.fechaNacimiento !== '' ? moment(certificado.fechaNacimiento).toDate() : null,
  fechaProbableParto: certificado.fechaProbableParto !== '' ? moment(certificado.fechaProbableParto).toDate() : null,
  fechaRealParto: certificado.fechaRealParto !== '' ? moment(certificado.fechaRealParto).toDate() : null,
  fechaVencimiento: certificado.fechaVencimiento !== '' ? moment(certificado.fechaVencimiento).toDate() : null,
  fecha2doVencimiento: certificado.fecha2doVencimiento !== '' ? moment(certificado.fecha2doVencimiento).toDate() : null,
  fechaActualizacion: certificado.fechaActualizacion !== '' ? moment(certificado.fechaActualizacion).toDate() : null,

});